import React from "react";
import { TransactionViewDetailsContainer } from "../../../containers";

const TransactionViewDetails = (props) => {
  return <TransactionViewDetailsContainer {...props} />;
};

export default TransactionViewDetails;
